module.exports = __webpack_public_path__ + "assets/img/z2.1653dcab.png";